'use client';

import { c as _c } from "react/compiler-runtime";
import { useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { REAUTH_REQUIRED_DIGEST } from '@lib/auth/errors/session-token-unavailable-error';
import { buildSignInRedirect } from '@lib/shared/components/invitation-page/utils/build-sign-in-redirect';

/**
 * App-wide error boundary. Recognizes a lapsed Clerk session token by its
 * stable digest (see SessionTokenUnavailableError) and re-authenticates the
 * user, returning them to where they were. Other errors are re-thrown so
 * their existing handling (global-error, observability) is unchanged.
 */
export default function AppError(t0) {
  const $ = _c(4);
  const {
    error
  } = t0;
  const router = useRouter();
  const isReauth = error.digest === REAUTH_REQUIRED_DIGEST;
  let t1;
  let t2;
  if ($[0] !== isReauth || $[1] !== router) {
    t1 = () => {
      if (!isReauth) {
        return;
      }
      const returnPath = window.location.pathname + window.location.search;
      router.replace(buildSignInRedirect(returnPath, {
        reauthRequired: true
      }));
    };
    t2 = [isReauth, router];
    $[0] = isReauth;
    $[1] = router;
    $[2] = t1;
    $[3] = t2;
  } else {
    t1 = $[2];
    t2 = $[3];
  }
  useEffect(t1, t2);
  if (!isReauth) {
    throw error;
  }
  return null;
}